/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_DownloadInputs */

const en_batch_download = /** @type {(inputs: Batch_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batch Download`)
};

const fr_batch_download = /** @type {(inputs: Batch_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargement par lots`)
};

const de_batch_download = /** @type {(inputs: Batch_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stapelverarbeitung`)
};

const it_batch_download = /** @type {(inputs: Batch_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download in blocco`)
};

const ru_batch_download = /** @type {(inputs: Batch_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пакетная загрузка`)
};

const es_batch_download = /** @type {(inputs: Batch_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarga por lotes`)
};

const zh_cn2_batch_download = /** @type {(inputs: Batch_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量下载`)
};

const ja_batch_download = /** @type {(inputs: Batch_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バッチダウンロード`)
};

const hi_batch_download = /** @type {(inputs: Batch_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बैच डाउनलोड`)
};

const pt_pt2_batch_download = /** @type {(inputs: Batch_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download em lote`)
};

/**
* | output |
* | --- |
* | "Batch Download" |
*
* @param {Batch_DownloadInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_download = /** @type {((inputs?: Batch_DownloadInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_DownloadInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_download(inputs)
	if (locale === "de") return de_batch_download(inputs)
	if (locale === "it") return it_batch_download(inputs)
	if (locale === "ru") return ru_batch_download(inputs)
	if (locale === "es") return es_batch_download(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_download(inputs)
	if (locale === "ja") return ja_batch_download(inputs)
	if (locale === "hi") return hi_batch_download(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_download(inputs)
	return en_batch_download(inputs)
});